import { GatsbyLink } from "@mgdx-libs/link";
import { cx } from "cva";

import { SubtleButtonLinkProps, variants } from ".";

export const SubtleButtonLink = ({
  className,
  children,
  align,
  radius,
  width,
  disabled,
  onClick,
  ...props
}: Readonly<SubtleButtonLinkProps>) => (
  <GatsbyLink
    aria-disabled={disabled}
    className={cx(className, variants({ align, radius, width }))}
    tabIndex={disabled ? -1 : undefined}
    onClick={disabled ? (event) => event.preventDefault() : onClick}
    {...props}
  >
    {children}
  </GatsbyLink>
);
